"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzIcon__Wrapper",
  componentId: "sc-19thi2d-0"
})(["\n  position: relative;\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  line-height: ", ";\n  margin: ", ";\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.margin;
});

var Image = _styledComponents.default.div.withConfig({
  displayName: "OzIcon__Image",
  componentId: "sc-19thi2d-1"
})(["\n  position: absolute;\n  top: 0%;\n  left: 0%;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  mask: url(", ") no-repeat 50% 50%;\n  mask-size: 100% 100%;\n\n  &:hover{\n    background-color: ", ";\n  }\n"], function (props) {
  return props.color;
}, function (props) {
  return props.icon;
}, function (props) {
  return props.hoverColor;
});

var OzIcon = function OzIcon(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "ozwol" : _ref$name,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#000000" : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "20px" : _ref$size,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "0px" : _ref$margin;
  return __jsx(Wrapper, {
    size: size,
    margin: margin
  }, __jsx(Image, {
    icon: "https://cdn.ozwol.cloud/ozwol/ui-icons/" + name + ".svg",
    color: color
  }));
};

var _default = OzIcon;
exports.default = _default;